import { useKrakenInfiniteQuery } from '@/components/GraphQLClient';
import { useAuth } from '@/components/Providers/Auth';
import { useAccountNumberContext } from '@/context/AccountNumberContext/withFetch/AccountNumberContext';
import Payments from '@/hooks/billsAndPayments/usePayments/Payments.graphql';
import { paymentsSuccessSchema } from '@/hooks/billsAndPayments/validations';

export const usePayments = ({
  ledgerNumber,
  first = 20,
}: {
  ledgerNumber?: string;
  first?: number;
}) => {
  const { isAuthenticated } = useAuth();

  const { accountNumber } = useAccountNumberContext();

  return useKrakenInfiniteQuery({
    queryKey: ['payments'],
    query: Payments,
    variables: { accountNumber, ledgerNumber, first },
    async validateFn(response) {
      const validatedDate = await paymentsSuccessSchema.validate(response);
      return validatedDate.account.transactions;
    },
    enabled: Boolean(isAuthenticated && accountNumber && ledgerNumber),
    getNextPageParam: (lastPage) =>
      lastPage.pageInfo?.hasNextPage ? lastPage.pageInfo.endCursor : undefined,
    initialPageParam: '0',
    select: (data) => data.pages[0],
  });
};
